import { useIntl } from 'react-intl';

// Agora este componente pode operar em dois modos:
// variant="basic" => apenas email/telefone
// variant="full" (default) => comportamento antigo (manter provisoriamente para retrocompatibilidade)
import { buildCanonicalAgenda } from '../../../helpers/person/agenda';

import { BrItem } from './BrItem';

export const ContactInfo = ({
  person,
  horizontal,
  showAllLinks = true,
  variant = 'full',
  isEditMode = false,
}) => {
  const intl = useIntl();
  if (!person) return null;

  const { primary } = buildCanonicalAgenda(person, intl);

  const hasBasic = person.email || person.telefone || primary;

  // Modo básico: SOMENTE e-mail e telefone
  if (variant === 'basic') {
    if (!person.email && !person.telefone) return null;
    return (
      <div
        className={
          'd-flex flex-column align-items-center gap-1 text-center w-100'
        }
      >
        {person.email && (
          <BrItem isEditMode={isEditMode}>{person.email}</BrItem>
        )}
        {person.telefone && (
          <BrItem isEditMode={isEditMode}>{person.telefone}</BrItem>
        )}
      </div>
    );
  }

  if (!hasBasic) return null;

  // Modo completo legado (mantido temporariamente)
  return (
    <div className="d-flex flex-column align-items-center gap-1 text-center w-100">
      {person.email && (
        <BrItem isEditMode={isEditMode}>
          <span title={person.email}>{person.email}</span>
        </BrItem>
      )}
      {person.telefone && (
        <BrItem isEditMode={isEditMode}>{person.telefone}</BrItem>
      )}
      {primary && (
        <BrItem href={primary.href} isEditMode={isEditMode}>
          {primary.label}
        </BrItem>
      )}
    </div>
  );
};
